import { api } from "~/api/index";
const createAddress = async (postCode) => {
    const addressData = await api.common.findAddress(postCode);
    return addressData.prefecture + addressData.city + addressData.town;
};
export { createAddress };
